export default [
  {
    header: 'PC Dashboards',
    // roles: {
    //   admin: ['read', 'write'],
    //   consultant: ['read', 'write'],
    //   supervisor: ['read', 'write'],
    //   client: ['read', 'write'],
    // },
  },
  {
    title: 'General',
    route: 'habit-general-dashboard',
    icon: 'GridIcon',
    moduleKey: 'general-dashboard',
  },
  {
    title: 'Confirmations',
    icon: 'BarChartIcon',
    route: 'habit-confirmation-dashboard',
    children: [{
      title: 'Global',
      route: 'habit-confirmation-dashboard',
      moduleKey: 'confirmations-global',
    },
    {
      title: 'Daily',
      route: 'habit-daily-dashboard',
      moduleKey: 'confirmations-daily',
    }],
  },
  {
    title: 'Adherence',
    icon: 'TrendingUpIcon',
    route: 'habit-adherence-dashboard',
    children: [{
      title: 'Processes',
      route: 'habit-adherence-dashboard',
      moduleKey: 'adherence-processes',
    },
    {
      title: 'Behaviours',
      route: 'habit-behaviour-dashboard',
      moduleKey: 'adherence-behaviours',
    },
    {
      title: 'Continuous Improvement',
      route: 'habit-commitment-dashboard',
      moduleKey: 'adherence-improvement',
    }],
  },
  {
    title: 'Case Management',
    route: 'organization-case-list',
    icon: 'ListIcon',
    moduleKey: 'case-management',
  },
]
